/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_Ca_EnInputs */

const en_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canadian English`)
};

const fr_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anglais canadien`)
};

const de_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanadisches Englisch`)
};

const it_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglese canadese`)
};

const ru_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`канадский английский`)
};

const es_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglés canadiense`)
};

const zh_cn2_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加拿大英语`)
};

const ja_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カナダ英語`)
};

const hi_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनाडाई अंग्रेजी`)
};

const pt_pt2_subtitle_export_vchip_type_ca_en = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês canadense`)
};

/**
* | output |
* | --- |
* | "Canadian English" |
*
* @param {Subtitle_Export_Vchip_Type_Ca_EnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_ca_en = /** @type {((inputs?: Subtitle_Export_Vchip_Type_Ca_EnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_Ca_EnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "de") return de_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "it") return it_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "es") return es_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_type_ca_en(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_type_ca_en(inputs)
	return en_subtitle_export_vchip_type_ca_en(inputs)
});